export default class DesktopMeganav {
    constructor() {
        const nav = document.querySelector('.js-meganav');

        if (!nav) return;

        this.nav = nav;
        this.scrim = document.querySelector('.js-meganav-scrim');
        this.items = [...nav.querySelectorAll('.menu > .menu-item-has-children')];
        this.openItem = null;

        this.items.forEach((item) => this.bindItem(item));

        nav.addEventListener('focusout', () => this.onFocusOut());
        document.addEventListener('keydown', (e) => this.onKeydown(e));
        // Header sits above the scrim, so clicks on the logo or empty header
        // strip never reach it - close on any click outside the nav instead.
        document.addEventListener('click', (e) => this.onDocumentClick(e));
        this.scrim?.addEventListener('click', () => this.closeAll());
    }

    bindItem(item) {
        const toggle = item.querySelector('.js-meganav__toggle');

        // The chevron is the only opener: the top-level heading stays a plain
        // link so the parent page is still reachable from the nav.
        toggle?.addEventListener('click', () => {
            this.openItem === item ? this.close(item) : this.open(item);
        });
    }

    open(item) {
        if (this.openItem && this.openItem !== item) this.close(this.openItem);

        item.classList.add('is-open');
        item.querySelector('.js-meganav__toggle')?.setAttribute('aria-expanded', 'true');
        this.openItem = item;
        this.toggleScrim(true);
    }

    close(item) {
        item.classList.remove('is-open');
        item.querySelector('.js-meganav__toggle')?.setAttribute('aria-expanded', 'false');

        if (this.openItem === item) this.openItem = null;
        if (!this.openItem) this.toggleScrim(false);
    }

    closeAll() {
        if (this.openItem) this.close(this.openItem);
    }

    onDocumentClick(e) {
        if (this.openItem && !this.nav.contains(e.target)) this.closeAll();
    }

    onKeydown(e) {
        if (e.key !== 'Escape' || !this.openItem) return;

        // Return focus to the toggle so keyboard users aren't dropped to <body>
        // when the panel (visibility:hidden) closes from under them.
        const toggle = this.openItem.querySelector('.js-meganav__toggle');
        const refocus = this.openItem.contains(document.activeElement);

        this.closeAll();

        if (refocus) toggle?.focus();
    }

    onFocusOut() {
        // Defer so the incoming focus target is known before deciding to close.
        requestAnimationFrame(() => {
            if (!this.nav.contains(document.activeElement)) this.closeAll();
        });
    }

    toggleScrim(active) {
        this.scrim?.classList.toggle('is-active', active);
    }
}
